// Single source of truth for the product brand. All CUSTOMER-FACING comms
// (deposit links, confirmations, emails, self-book) are sent from Tattoo Vault
// — never from an individual studio brand, because the network runs many
// studio brands (Addikted to Ink, Black Book Tattoo, …) and is still growing.
// Internal/agent-facing screens still show the real studio.brand.
import type { Studio } from '@/domain/types';

export const PRODUCT_BRAND = 'Tattoo Vault';

/** Instagram / social handle used in outbound customer comms. */
export const PRODUCT_SOCIAL_HANDLE = 'tattoovault';

/**
 * How a customer-facing message identifies its sender: the product brand plus
 * the studio location (e.g. "Tattoo Vault Coburg"), never the studio's own
 * brand name.
 */
export function customerFacingSender(studio: Studio): string {
  return `${PRODUCT_BRAND} ${studio.name}`;
}
